import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * SKU bulk upload state
 * Manages bulk SKU registration data for inventory financing
 */
export interface BulkState {
  skus: any[]; // TODO: Define proper SKU type
}

const initialState: BulkState = {
  skus: [],
};

const bulkSlice = createSlice({
  name: "skubulk",
  initialState,
  reducers: {
    setRegisterBulk: (state, action: PayloadAction<{ skus: any[] }>) => {
      state.skus = action.payload.skus;
    },
  },
});

export const { setRegisterBulk } = bulkSlice.actions;

export default bulkSlice.reducer;
